import Grid from '@mui/material/Grid2';
import FactoryIcon from '@mui/icons-material/Factory';
import RecyclingIcon from '@mui/icons-material/Recycling';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CtaButton from '../../components/CtaButton/CtaButton';

const PROFILES = [
  {
    role: "Productores",
    description: "Cumple tus metas REP sin riesgo",
    Icon: FactoryIcon,
  },
  {
    role: "Gestores",
    description: "Registra y certifica material con valor",
    Icon: RecyclingIcon,
  },
  {
    role: "Transformadores",
    description: "Respalda tu operación con trazabilidad",
    Icon: PrecisionManufacturingIcon,
  },
  {
    role: "Sistemas colectivos",
    description: "Centraliza y valida la gestión",
    Icon: AccountBalanceIcon,
  },
];

function AudienceSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto py-96 px-40 text-center">
        <h2 className="text-40 font-extrabold text-[#1E3A8A] mb-64 leading-[1.2]">
          Diseñado para cada actor de la cadena
        </h2>
        <Grid container spacing={3}>
          {PROFILES.map(({ role, description, Icon }) => (
            <Grid key={role} size={{ xs: 12, sm: 6, md: 3 }}>
              <div className="group border-2 border-[#1A56DB] rounded-[14px] py-40 px-24 h-full cursor-default transition-[background,transform] duration-200 ease-out hover:bg-[#1A56DB] hover:-translate-y-[4px]">
                <Icon className="!text-[4.8rem] text-[#1A56DB] mb-16 transition-colors duration-200 group-hover:text-white" />
                <h3 className="text-20 font-bold text-[#1A56DB] mb-12 transition-colors duration-200 group-hover:text-white">
                  {role}
                </h3>
                <p className="text-18 text-[#555] m-0 leading-[1.6] transition-colors duration-200 group-hover:text-white">
                  {description}
                </p>
              </div>
            </Grid>
          ))}
        </Grid>
        <div className="mt-56">
          <CtaButton to="/soluciones">Ver soluciones por perfil</CtaButton>
        </div>
      </div>
    </section>
  );
}

export default AudienceSection;
